import { render, staticRenderFns } from "./accordion.vue?vue&type=template&id=250b6ab1&scoped=true&lang=pug&"
import script from "./accordion.vue?vue&type=script&lang=js&"
export * from "./accordion.vue?vue&type=script&lang=js&"
import style0 from "./accordion.vue?vue&type=style&index=0&id=250b6ab1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250b6ab1",
  null
  
)

export default component.exports